import { FiLoader } from 'react-icons/fi'

interface FinancePageLoadingProps {
  message?: string
}

export default function FinancePageLoading({
  message = 'Loading…',
}: FinancePageLoadingProps) {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="flex flex-col items-center gap-3">
        <FiLoader className="animate-spin" style={{ width: '32px', height: '32px', color: '#212126' }} />
        <span style={{ fontFamily: 'Lexend Deca', fontWeight: 400, fontSize: '14px', color: '#69697A' }}>
          {message}
        </span>
      </div>
    </div>
  )
}
